  import axiosInstance from "../Instance/axiosInstance";

  export const getAllInvoices = () => {
    return axiosInstance.get("/admin/get-all-invoices");
  };

   export const getAllCancelRequests = () => {
    return axiosInstance.get("/orders/getAllCancelRequest");
  };
   export const getAllCancelledOrders = () => {
    return axiosInstance.get("/orders/cancelled");
  };

  // ✅ UPDATE ORDER STATUS (NEW API)
  export const updateOrderTracking = (data: {
    orderId: number;
    orderStatus: string;
  }) => {
    return axiosInstance.post("/order-tracking/create", data);
  };

  // ✅ ADMIN: APPROVE / REJECT CANCEL REQUEST
export const updateCancelOrderStatus = (
  orderId: number,
  data: { orderCancelStatus: "Approved" | "Rejected" }
) => {
  return axiosInstance.patch(`/orders/cancel-status/${orderId}`, data);
};
// ✅ Complete Refund API
export const completeRefund = (orderId: number) => {
  return axiosInstance.post(`/orders/${orderId}/refund/complete`);
};

// ✅ Get all delivery boys
export const getAllDeliveryBoys = () => {
  return axiosInstance.get("/admin/delivery-boys");
};

// ✅ Assign delivery boy
export const assignDeliveryBoy = (orderId: string, data: any) => {
  return axiosInstance.post(`/assign-delivery-boy/${orderId}`, data);
};


export const updateAdminStatusForDelivery = (
  orderId: string,
  data: { adminStatus: "Come to Office" | "Go for Delivery"|   "Rejected";}
) => {
  return axiosInstance.put(
    `/admin/update-admin-status/${orderId}`,
    data
  );
};

export const updatePriceVisibility = (
  orderId: string,
  data: { priceVisibility: number }
) => {
  return axiosInstance.put(
    `/update-price-visibility/${orderId}`,
    data
  );
};

export const updateAdminStatusForReturn = (
  orderId: string,
  data: { adminStatus: "Come to Office" | "Go for Delivery" | "Rejected" }
) => {
  return axiosInstance.put(`/return-delivery/admin-status/${orderId}`, data);
};

// ✅ NEW: Assign return delivery boy for cancelled orders
export const assignReturnDeliveryBoy = (orderId: string, data: { deliveryBoyId: string }) => {
  return axiosInstance.put(`/assign-return-delivery-boy/${orderId}`, data);
};